import { type PropsWithChildren, type ReactNode } from 'react';
import { OverlayComponent } from '@epihub/web/src/components/OverlayComponent';
import { styled } from '@epihub/web/src/_ctx/theme';

type Props = {
  skeleton: ReactNode;
  __debug?: boolean;
  renderChildrenHidden?: boolean;
};

export const OverlaySkeleton = ({
  // the actual skeleton
  skeleton,
  // When loading = true the skeleton is rendered INSTEAD of the children
  loading,
  // When __debug = true both the skeleton AND the children are rendered
  __debug,
  // The children
  children,
  // If true then children are always rendered but with opacity 0
  // This can be used when for example we need to mount the children
  // to trigger them to load
  renderChildrenHidden,
}: PropsWithChildren<Props & { loading: boolean }>) => {
  if (__debug) {
    return (
      <OverlayComponent
        background={(
          <DebugBackground>
            {children}
          </DebugBackground>
        )}
      >
        <DebugChildren>
          {skeleton}
        </DebugChildren>
      </OverlayComponent>
    );
  }

  if (loading) {
    return (
      <>
        {skeleton}
        {renderChildrenHidden && <div style={{ opacity: 0 }}>{children}</div>}
      </>
    );
  }

  return (
    <>
      {children}
    </>
  );
};

const DebugBackground = styled.div`
  opacity: 1;
  position: fixed;
  width: 100%;
  height: 100%;
`;

const DebugChildren = styled.div`
  opacity: 0.2;
`;
